import { render, staticRenderFns } from "./Presave.vue?vue&type=template&id=180b9132"
import script from "./Presave.vue?vue&type=script&lang=js"
export * from "./Presave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports